import React, { ReactNode } from 'react';

import './modal.scss';

type Props = {
  text: string;
  title: string;
  isText: boolean;
  isOpen: boolean;
  children: ReactNode;
  toggleModal: () => void;
};

function Modal(props: Props) {
  function getClass() {
    return props.isOpen ? 'show' : 'hide';
  }

  return (
    <div className={`modal ${getClass()}`}>
      <div className="modal-container">
        <div className="modal-header">
          <span className="modal-title">{props.title}</span>
          <button className="modal-button" type="button" onClick={() => props.toggleModal()}>
            <img className="modal-img" src="assets/close.png" alt="" />
          </button>
        </div>
        <div className="modal-content">
          {props.isText && <p className="modal-text">{props.text}</p>}
          {props.children}
        </div>
      </div>
    </div>
  );
}

export default Modal;
